// extracted by mini-css-extract-plugin
module.exports = {"cannotFound":"productSearch_cannotFound__3Y4ik","searchBox":"productSearch_searchBox__1P05a"};